module.exports = __webpack_public_path__ + "media/Images/PendingCommitmentsCount-589a7170.svg";